<template>
  <base-form
    v-slot="slotProps"
    :model="number"
    :rules="rules"
    :loading="loading"
    :form-submitted="formSubmitted"
    :submit-label="submitLabel"
    :mode="mode"
    model-name="Nummer"
  >
    <el-form-item label="Name" prop="name">
      <el-input v-model="slotProps.model.name" v-focus></el-input>
    </el-form-item>

    <el-form-item label="Telefonnummer" prop="number">
      <el-input v-model="slotProps.model.number"></el-input>
    </el-form-item>
  </base-form>
</template>

<script>
import BaseForm from "@/components/forms/BaseForm"

export default {
  components: {
    BaseForm
  },
  props: {
    number: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLabel: {
      type: String,
      default: "Änderungen speichern"
    },
    formSubmitted: {
      type: Function,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rules: {
        name: [
          { required: true, message: "Bitte Namen angeben", trigger: "blur" }
        ],
        number: [
          { required: true, message: "Bitte Nummer angeben", trigger: "blur" }
        ]
      }
    }
  },
  created() {},
  methods: {}
}
</script>
